import { localStorageService, localStorageTypes } from '@eva/emf/app/services/localStorage';

export const getUserGroupIds = () =>
  localStorageService
    .getItem(localStorageTypes.userGroupIds)
    .split(',')
    .map((userGroupId) => Number(userGroupId));
